import axios from 'axios'
var  theHeader = ''


// 添加请求拦截器
axios.interceptors.request.use(function (config) {
    
    // if(theHeader != ''){
    //     config.headers.authorization = theHeader
    // }
    if(sessionStorage.getItem('token')){
        config.headers.Authorization = sessionStorage.getItem('token');
    }
　　return config

}, function (error) {
　　// 对请求错误做些什么
    return Promise.reject(error)
});

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  
    const status = response.status
    if(status === 200){

    }else if(status === 403){
        this.$router.push({ path:'/loging'})
    }
    
    // if(theHeader != response.headers.authorization){
    //     theHeader = response.headers.authorization
    // }
    if(sessionStorage.getItem('token') != response.headers.authorization && response.headers.authorization){
        sessionStorage.setItem('token',response.headers.authorization)
    }

　　// 对响应数据做点什么
　　return response
}, function (error) {
　　// 对响应错误做点什么
　　return Promise.reject(error)
});




//////////////////
// WEBPACK FOOTER
// ./config/axios.js
// module id = 729
// module chunks = 471